import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import ReviewForm from '../Form';
import { createReview } from '@resources/Review/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { module, createReview, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createReview(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.review.create',
						defaultMessage:
							'A new Review has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.review',
					defaultMessage: 'Create Review',
				})}
			</Title>
			<Section className="mb-5">
				<ReviewForm
					onSubmit={handleSubmit}
					{...props}
					module={module}
				/>
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	reviews,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
}) => {
	return {
		reviews,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
	};
};

export default connect(mapStateToProps, {
	createReview,
})(Create);
